import { ContractActions } from "../actions";

const initialState = {
  contracts: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  contract: null,
};

export default function contract(state = initialState, action) {
  switch (action.type) {
    case ContractActions.ACTION_SAVE_CONTRACTS:
      return {
        ...state,
        contracts: action.payload,
      };
    case ContractActions.ACTION_STATUS_PDF:
      return {
        ...state,
        contracts: action.payload,
      };
    case ContractActions.ACTION_SAVE_CONTRACTS_CONSOLIDATED:
      return {
        ...state,
        contracts: action.payload,
      };
    case ContractActions.ACTION_SAVE_CONTRACT:
      return {
        ...state,
        contract: action.payload,
      };
    case ContractActions.ACTION_CLEAR_CONTRACTS_LIST:
      return {
        ...state,
        contracts: initialState.contracts,
      };
    default:
      return state;
  }
}

export function getContracts(state) {
  return state.contract.contracts;
}

export function getContract(state) {
  return state.contract.contract;
}
